<template>
  <div id="pageRoot">
	<div class="enciclopedia">
	<p class="textBaseCourier" id="text01">
		ENCICLOPEDIA
	</p>
	<p class="textBaseCourier" id="text02">
		LOS GRILLOS*
	</p>
	<p class="textBaseCourier" style="
	position: absolute;
	width: 400px;
	height: 133px;
	left: 44px;
	top: 219px;

	font-size: 22px;
	line-height: 33px;"
	>
		Los grillos son insectos.<br>Sus hábitos son nocturnos, eso significa que están activos durante la noche y ocultos durante el día. En algunos países las personas consumen grillos como alimento.
	</p>

	<img src="/pages/img/sordovio/assets_p32/grillo.png"  style="
	position: absolute;
	width: 330px;
	left: 502px;
	top: 208px;">

	<img src="/pages/img/sordovio/assets_p32/circulo.svg"  style="
	position: absolute;
	width: 150px;
	left: 240px;
	top: 212px;">

	<p class="textBaseCourier" id="text04" style="
	width: 700px;
	height: 51px;
	left: 40px;
	top: 490px;">
		EL "CANTO" DE LOS GRILLOS
	</p>
	<p class="textBaseCourier" id="text05">
		Los grillos machos producen un sonido para atraer a las hembras. Este sonido no es un verdadero "canto". Para lograrlo los grillos levantan ligeramente las alas y las frotan contra las patas de atras. Cada especie tiene un sonido diferente a las demás.
	</p>
</div>
  </div>
</template>
<style scoped>
#text01
{
position: absolute;
width: 402px;
height: 78px;
left: 253px;
top: 59px;

font-size: 50px;
line-height: 55px;
text-align: center;
letter-spacing: 0.015em;

color: #231F20;
}
#text02
{
position: absolute;
width: 848px;
height: 51px;
left: 40px;
top: 158px;

font-weight: bold;
font-size: 47px;
line-height: 53px;

color: #231F20;
}
#text03
{
position: absolute;
width: 843px;
height: 133px;
left: 44px;
top: 219px;

font-size: 22px;
line-height: 33px;

color: #000000;
}
#text04
{
position: absolute;

font-weight: bold;
font-size: 35px;
line-height: 40px;

color: #231F20;
}
#text05
{
position: absolute;
width: 860px;
height: 198px;
left: 40px;
top: 543px;

font-size: 22px;
line-height: 33px;

color: #000000;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "vio/Video 103.mp4",
        "vio/Video 103b.mp4",
        "vio/Video 104.mp4",
        "vio/Video 105.mp4",
		"vio/Video 106.mp4",
      ],
    };
  },
};
</script>